export default __webpack_public_path__ + "static/media/success.be7c5034.svg";